import {
  Briefcase, FileWarning, Palmtree, TrendingUp, ArrowRightLeft, FileText,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface FormPresentation {
  icon: LucideIcon;
  actionLabel: string;
}

const PRESENTATION_BY_NAME: Record<string, FormPresentation> = {
  "Abertura de Vagas": { icon: Briefcase, actionLabel: "Nova vaga" },
  "Solicitação de Desligamentos": { icon: FileWarning, actionLabel: "Novo desligamento" },
  "Solicitação de Férias": { icon: Palmtree, actionLabel: "Enviar solicitação" },
  "Solicitação de Promoções / Mudanças de Cargo": { icon: TrendingUp, actionLabel: "Criar solicitação" },
  "Transferência de Setor/Área": { icon: ArrowRightLeft, actionLabel: "Enviar solicitação" },
};

export function getFormIcon(name: string): LucideIcon {
  return PRESENTATION_BY_NAME[name]?.icon ?? FileText;
}

export function getFormActionLabel(name: string): string {
  return PRESENTATION_BY_NAME[name]?.actionLabel ?? "Enviar solicitação";
}
